



































































































import {
  computed,
  defineComponent,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import _ from 'lodash';

import { getMe } from '@/api';
import useAuth from '@/use/useAuth';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

const Profile = defineComponent({
  components: { CommonModalWithPreset },
  setup(props, { root }) {
    const { hasPermission: checkPermissionHandler } = useAuth();
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }
    const form = reactive({
      newPassword: '',
    });

    return {
      form,
      hasPermission,
    };
  },
});

export default Profile;
